module.exports = __webpack_public_path__ + "img/videoList.1c9665f8.svg";